<template>
  <div>
    <div class="az-form-content">
      <p v-if="itensELotes.lotes.length === 0
              && itensELotes.itens.length === 0"
         class="mensagem-quando-vazio">
        Não há itens para esta compra direta.
      </p>

      <div v-else>
        <painel-lote-visualizacao v-if="itensELotes.lotes.length > 0 && compraDireta"
                                  v-model="itensELotes.lotes"
                                  class="mb-3"
                                  :possuiValorReferencia="compraDireta.possuiValorReferencia"
                                  :exibeValorReferencia="compraDireta.exibeValorReferencia"
                                  :prefixOuSuffixValor="prefixOuSuffixValor"
                                  :criterioJulgamento="criterioJulgamento"
                                  :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                                  :casasDecimais="itensELotes.casaDecimal"
                                  :casasDecimaisQuantidade="itensELotes.casasDecimaisQuantidade"/>

        <painel-item-visualizacao v-if="itensELotes.itens.length > 0 && compraDireta"
                                  v-model="itensELotes.itens"
                                  :possuiValorReferencia="compraDireta.possuiValorReferencia"
                                  :exibeValorReferencia="compraDireta.exibeValorReferencia"
                                  :prefixOuSuffixValor="prefixOuSuffixValor"
                                  :criterioJulgamento="criterioJulgamento"
                                  :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                                  :casasDecimais="itensELotes.casaDecimal"
                                  :casasDecimaisQuantidade="itensELotes.casasDecimaisQuantidade"/>

      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'
import PainelLoteVisualizacao from '@/views/pages/commons/detalhe-compra-direta/itens/paineis/PainelLoteVisualizacao.vue'
import PainelItemVisualizacao from '@/views/pages/commons/detalhe-compra-direta/itens/paineis/PainelItemVisualizacao.vue'
export default {
    name: 'ItensLotesPublico',
    components: {
        PainelItemVisualizacao,
        PainelLoteVisualizacao
    },
    data() {
        return {
            compraDiretaId: null,
            criteriosJulgamento: {
                MENOR_PRECO: {texto: 'Menor Preço', valor: 'MENOR_PRECO'},
                MAIOR_DESCONTO: {texto: 'Maior Desconto', valor: 'MAIOR_DESCONTO'},
            }
        }
    },
    computed: {
        ...mapState(['itensELotes', 'compraDireta']),
        totalGeral() {
            let totalItens = 0
            let totalLotes = 0
            this.itensELotes.itens.forEach(item => {
                if (item.totalEstimado > 0) {
                    totalItens += item.totalEstimado
                }
            })
            this.itensELotes.lotes.forEach(lote => {
                if (lote.totalGeral > 0) {
                    totalLotes += lote.totalGeral
                }
            })
            return totalItens + totalLotes
        },
        prefixOuSuffixValor(){
            return this.compraDireta.prefixoValor
        },
        criterioJulgamento(){
            return this.compraDireta.criterioJulgamento
        },
        isCriterioJulgamentoMaiorDesconto(){
            return this.compraDireta.criterioJulgamento === this.criteriosJulgamento.MAIOR_DESCONTO.valor
        },
        prefix(){
            return this.compraDireta.prefixoValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.compraDireta.prefixoValor === '%' ? '%' : ''
        }
    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarItensLotes()
            await this.buscarCompraDireta()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarItensLotes() {
            await this.$store.dispatch(actionTypes.BUSCAR_ITENS_E_LOTES, this.compraDiretaId)
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        },
        async buscarCompraDireta(){
            await this.$store.dispatch(actionTypes.BUSCAR_DADOS_GERAIS_PUBLICO, this.compraDiretaId)
        },
    }
}
</script>

<style scoped>
.az-actions-form {
  padding: 0;
}
</style>